import { onMounted, onUnmounted, type Ref } from 'vue'

export function useClickOutside(
  elementRef: Ref<HTMLElement | null>,
  excludeSelectors: string[] = ['.dropdown-overlay-wrapper'],
  callback: (event: Event) => void,
) {
  const handleClick = (event: Event) => {
    // 获取实际的文档根节点
    const getContext = (element: HTMLElement | null): Document | ShadowRoot => {
      if (!element) return document

      const root = element.getRootNode()
      if (root instanceof ShadowRoot) {
        return root
      }
      return document
    }

    const context = elementRef.value ? getContext(elementRef.value) : document

    // 检查是否在排除的选择器中
    const isExcluded = excludeSelectors.some((selector) => {
      const element = context.querySelector(selector)
      return element && (element === event.target || element.contains(event.target as Node))
    })

    console.log('isExcluded:' + isExcluded)

    if (isExcluded) return

    // 检查是否在目标元素外部
    if (elementRef.value && !elementRef.value.contains(event.target as Node)) {
      callback(event)
    }
  }

  onMounted(() => {
    // 获取正确的事件监听目标
    const getEventTarget = () => {
      if (elementRef.value) {
        const root = elementRef.value.getRootNode()
        if (root instanceof ShadowRoot) {
          // 在 Shadow DOM 内，监听 shadowRoot
          return root
        }
      }
      return document
    }

    const target = getEventTarget()
    target.addEventListener('click', handleClick)

    onUnmounted(() => {
      target.removeEventListener('click', handleClick)
    })
  })
}
